// ----------------------------------------------------------------------
// <copyright file="Izenda.UserMenu.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import actions from 'share/components/layout/Izenda.UserMenuActions';
import { Link } from 'react-router';
import uiState from 'logic/Izenda.UiState';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import Config from 'Izenda.Config';
import NotificationBoard from 'share/components/controls/Izenda.NotificationBoard';
import HelpSystem from 'share/components/controls/Izenda.HelpSystem';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import { truncate } from 'lodash/fp';

@connect(actions)
export default class UserMenu extends Component {

  preventLeftButton = (e) => {
    if (e.button === 0)
      e.preventDefault();
  };
  goToProfile = (openExportManager) => {
    const {props, props: {router}} = this;
    const myProfileUrl = routeUtils.getMyProfileUrl();

    return (e) => {
      this.preventLeftButton(e);
      props
        .confirmDirtyForm(uiState.isDirty, {onConfirmDirtyForm: uiState.onOkDirtyForm})
        .then(function () {
          if(openExportManager){
            uiState.setOpenExportManagerStatus(true);
          }
          if(!router.isActive(myProfileUrl)){
            router.push(myProfileUrl);
          }else{
            router.go(myProfileUrl);
          }
        });
    }
  };
  renderMyProfileLink() {
    const {props: {localization}, goToProfile } = this;

    return (
      <li>
        <a onClick={goToProfile()}>{localization.getText('USER_MENU_MY_PROFILE')}</a>
      </li>
    );
  };
  renderExportManagerLink() {
    const {props: {localization}, goToProfile } = this;

    return (
      <li>
        <a onClick={goToProfile(true)}>{localization.getText('USER_MENU_EXPORT_MANAGER')}</a>
      </li>
    );
  };
  renderNotificationLink(Dashboard,Id,Name) {
    const {props} = this;
    const {router} = props;
    let notificationUrl;
    if(JSON.parse(Dashboard))
    {
      notificationUrl = routeUtils.getDashboardUrl('Edit', {id: Id});
    }
    else{
        notificationUrl= routeUtils.getReportUrl('View', { id: Id });
    }
    // report and dashboard viewer action
    const goToViewer = (e) => {
      this.preventLeftButton(e);
      props
        .confirmDirtyForm(uiState.isDirty, {onConfirmDirtyForm: uiState.onOkDirtyForm})
        .then(function () {
          router.push(notificationUrl);
        });
     
       
    };

    return (
      <Link to={notificationUrl} onClick={goToViewer} className="report-link">
          {Name}
      </Link>
    );
  }
  render() {
    const {props} = this;
    const {localization} = props;

    const myProfileUrl = routeUtils.getMyProfileUrl();
    const fullName = truncate({length: 30}, uiState.currentUser.fullName);
    const isProfileHidden = uiState.expiredLicense || uiState.currentUser.isUserProfileHidden;
    const isSignOutHidden = Config.Integration;

    return (
      <div className={`izenda-UserMenu u-posAbsolute ${!uiState.currentUser.systemAdmin ? 'izenda-UserMenu--add-top' : ''}`}>

        <HelpSystem/>
        <div className="izenda-UserMenu-Bell u_fullInlineBlock">
          <NotificationBoard store={props.store} renderNotificationLink={this.renderNotificationLink.bind(this)}/>
        </div>

        <div className="btn-group izenda-UserMenu-Info" role="group">
          <a href={myProfileUrl}
             onClick={this.preventLeftButton}
             className="btn dropdown-toggle"
             ref={dom => dom && $izenda(dom).dropdown()}
             aria-haspopup
             aria-expanded="false"
             data-toggle="dropdown"
             title={uiState.currentUser.fullName}>
            <OverflowText className='izenda-UserMenu-Username' tooltip={fullName}>{fullName}</OverflowText> &nbsp;
            <i className="icon-arrow-down izenda-UserMenu-icon" />
            {uiState.currentUser.systemAdmin && (
                <OverflowText className='izenda-UserMenu-Admin'>Admin</OverflowText>
            )}
          </a>
          <ul className="dropdown-menu">
            {!isProfileHidden && this.renderMyProfileLink()}
            {this.renderExportManagerLink()}
            {!isSignOutHidden && (
              <li>
                <a onClick={props.onClickSignOut}>{localization.getText('USER_MENU_SIGN_OUT')}</a>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.UserMenu.js